<template>
  <div>
    <general-top-bar :title="$t('reports.preordersItems')"></general-top-bar>
    <div class="sales-report">
      <div class="row mar-bt-15">
        <div class="col-md-6" v-if="showLocations">
          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <option v-for="loc in locations" :key="'loc-' + loc.id" :label="loc.name" :value="loc.id">{{loc.name}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
        </div>
        <div class="pull-left" style="display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 10px;">
          {{$t('general.from')}}
          <el-time-select
            :placeholder="$t('catalogProd.timePlaceholder')"
            :value="valid_from"
            v-model="valid_from"
            :change="changeValidFrom()"
            class="mar-rt-5"
            :picker-options="{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }">
          </el-time-select>
          {{$t('general.to')}}
          <el-time-select
            :placeholder="$t('catalogProd.timePlaceholder')"
            :value="valid_to"
            v-model="valid_to"
            :change="changeValidFrom()"
            class="mar-lt-5"
            :picker-options="{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }">
          </el-time-select>
        </div>
        <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
        </div>
        <div class="search-button-reports form-group pull-left">
          <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
        </div>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;">{{ $t('reports.filteredData') }} <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:59</b></p>
      </div>

      <div class="col-md-12" v-if="ordersTableData.data && ordersTableData.data.length > 0">
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-content" v-loading="loading">
                <div class="report-container-compact">
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.orderCounter')}}</div>
                    <div class="report-col right-align">{{totalCounter}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="card-content total-pagination reports-center-columns">
            <data-tables-server
              @query-change="paginationChanged"
              v-loading="loading"
              :data="ordersTableData.data"
              :total="totalRecords"
              :search-def="{show: false}"
              :pagination-props="paginationProps"
              class="report-sales"
              key="preorders-items-table"
              style="width: 100%"
              ref="reportsTable">

              <el-table-column class-name="centered-cell" :min-width="100" prop="quantity" :label="$t('reports.quantity')">
                <template slot-scope="props">
                  <template v-if="props.row._isProductRow">{{ props.row.quantity || '' }}</template>
                </template>
              </el-table-column>

              <el-table-column class-name="centered-cell" :min-width="200" prop="product" :label="$t('reports.productName')">
                <template slot-scope="props">
                  <template v-if="props.row._isProductRow">{{ props.row.product || props.row.item_name || props.row.name || '' }}</template>
                </template>
              </el-table-column>

              <el-table-column class-name="centered-cell" :min-width="300" :label="$t('reports.options')">
                <template slot-scope="props">
                  {{ props.row.option || '-' }}
                </template>
              </el-table-column>
            </data-tables-server>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {DatePicker} from 'element-ui'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
import moment from 'moment'
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
  components: {
    GeneralTopBar,
    [DatePicker.name]: DatePicker,
    ChartCard,
    ChartBarsCard
  },
  props: {
    isPreordersItems: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isPreordersItems () {
      if (this.isPreordersItems) {
        this.getOrders()
      }
    }
  },
  created () {
    this.getOrders()
    this.verifyUserLocations()
  },
  data () {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      loading: true,
      orders: {
        'valid': [
          moment().date(1).format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total',
        pageSize: 20,
        currentPage: 1,
        pageSizes: [20, 50, 100]
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      ordersTableData: {
        data: []
      },
      totalRecords: 0,
      totalAmount: 0,
      totalCounter: 0,
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      hasRceipt: null,
      colors: [
        '#f44336', // red
        '#2196f3', // blue
        '#ff9800', // orange
        '#9c27b0', // purple
        '#00bcd4', // cyan
        '#8bc34a', // light green
        '#ffc107', // amber
        '#3f51b5', // indigo
        '#ff5722', // deep orange
        '#795548', // brown
        '#607d8b', // blue grey
        '#009688', // teal
        '#cddc39', // lime
        '#673ab7', // deep purple
        '#03a9f4', // light blue
        '#aed581', // soft green
        '#ffb74d', // soft orange
        '#ba68c8'  // soft purple
      ],
      noData: false
    }
  },
  methods: {
    changeValidFrom () {
      if (!this.valid_from) {
        this.valid_from = '00:00'
      }
      if (!this.valid_to) {
        this.valid_to = '23:59'
      }
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))

        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    getOrders (query) {
      if (!this.isPreordersItems) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1

      this.apiRequest('/reports/v2/preorders-items' + '?page=' + page + '&per_page=' + pageSize, 'GET', data, response => {
        if (response.status) {
          // Handle new response structure: response.data is an array
          const items = Array.isArray(response.data) ? response.data : (response.data.items || response.data.table_data || [])

          // Expand items with multiple options into multiple rows
          const expandedItems = []
          items.forEach((item, index) => {
            const baseName = item.product || item.item_name || item.name || 'item'
            const options = Array.isArray(item.options) ? item.options : []

            // First, add a row with the product name and first option (if exists)
            expandedItems.push({
              ...item,
              option: options.length > 0 ? options[0] : null,
              _rowKey: `${baseName}-${index}-product`,
              _isProductRow: true
            })

            // Then, add a row for each remaining option (skip first one)
            if (options.length > 1) {
              options.slice(1).forEach((option, optIndex) => {
                expandedItems.push({
                  ...item,
                  option: option,
                  _rowKey: `${baseName}-${index}-${optIndex + 1}`,
                  _isProductRow: false
                })
              })
            }
          })

          if (expandedItems && expandedItems.length) {
            this.noData = false
            this.ordersTableData.data = expandedItems
            this.ordersTableData.total = expandedItems.length
            // Note: totalRecords is based on expanded rows for current page
            // Server pagination is based on items, but we display expanded rows
            this.totalRecords = response.pagination ? response.pagination.total : expandedItems.length
            this.paginationProps.currentPage = response.pagination ? response.pagination.page : page
            this.paginationProps.pageSize = response.pagination ? response.pagination.perPage : pageSize

            // Calculate totals from original items (before expansion)
            this.totalCounter = items.reduce((sum, item) => sum + (parseInt(item.quantity) || 0), 0)
            // If total amount is provided separately, use it; otherwise calculate from items
            this.totalAmount = response.data.total || 0
          } else {
            this.noData = true
            this.ordersTableData.data = []
            this.ordersTableData.total = 0
            this.totalRecords = 0
            this.paginationProps.currentPage = page
            this.paginationProps.pageSize = pageSize
          }
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      this.getOrders()
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    exportData () {
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loading = true
      // First, check if there is any data for the current filters.
      this.apiRequest('/reports/v2/preorders-items?page=1&per_page=1', 'GET', data, response => {
        if (response && response.status) {
          const pagination = response.pagination || {}
          const total = pagination.total != null ? pagination.total : 0

          if (!total) {
            // No data for current filters → show friendly message and skip download.
            swal(
              '',
              this.$t('reports.noData') || 'Nu există date',
              'info'
            )
            this.loading = false
            return
          }

          // There is data → proceed with download.
          this.apiRequest('/reports/v2/preorders-items-download', 'GET', data, downloadResponse => {
            if (downloadResponse && downloadResponse.status === true) {
              const link = document.createElement('a')
              link.href = downloadResponse.data.file
              link.setAttribute('download', downloadResponse.data.file_name)
              document.body.appendChild(link)
              link.click()
            } else {
              swal(
                '',
                this.$t('validations.wentWrong'),
                'error'
              )
            }
            this.loading = false
          })
        } else {
          swal(
            '',
            this.$t('validations.wentWrong'),
            'error'
          )
          this.loading = false
        }
      })
    },
    paginationChanged (query) {
      this.getOrders(query)
    }
  }
}
</script>
<style>
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-container-compact {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 20px 30px;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .report-container-compact .report-row {
    margin-bottom: 0;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  .report-container-compact .report-col:nth-child(1){
    font-size: 14px;
  }
  .report-container-compact .report-col:nth-child(2){
    font-size: 16px;
    font-weight: 600;
  }

  .centered-cell .cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/PreordersItems.vue